import React from 'react';
import './Modal.css';

const Modal  = ({ isOpen, onClose }) => {
    if (!isOpen) return null;
   
  return (
    <div className="modal-overlay">
    <div className="modal-content pncModal">
      <button className="close-button" onClick={onClose}>
        {/* /&times; The X symbol */}
        <svg class="fui-Icon-regular ___12fm75w f1w7gpdv fez10in fg4l7m0" fill="currentColor" aria-hidden="true" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m4.09 4.22.06-.07a.5.5 0 0 1 .63-.06l.07.06L10 9.29l5.15-5.14a.5.5 0 0 1 .63-.06l.07.06c.18.17.2.44.06.63l-.06.07L10.71 10l5.14 5.15c.18.17.2.44.06.63l-.06.07a.5.5 0 0 1-.63.06l-.07-.06L10 10.71l-5.15 5.14a.5.5 0 0 1-.63.06l-.07-.06a.5.5 0 0 1-.06-.63l.06-.07L9.29 10 4.15 4.85a.5.5 0 0 1-.06-.63l.06-.07-.06.07Z" fill="currentColor"></path></svg>
      </button>
      <h2 className='aboutHeading'>About</h2>
      <div className='aboutContent'>
      <p className='aboutDetails'>
        Chatbot is your everyday AI companion with enterprise-grade security, privacy, and compliance. 
        This Chatbot combines the power of large language models (LLMs) with up-to-date information from the web 
        to give you better answers, greater efficiency, and new ways to be creative. For example, get quick summaries 
        of the content you view online, compare products to make informed business decisions, analyze images, draft content, and more. 
        Get started with Copilot by asking a question or giving instructions. Or try one of these: 
        Give me a summary of recent news about [product] Help me learn about [topic] 
        How do I set achievable goals at work? You can ask follow-up questions to fine-tune the response. 
        AI-generated content may be incorrect, so sources are provided for your review when possible. 
        Chatbot data associated with your work or school account may be provided to your organization.
      </p>
      </div>
    </div>
  </div>
  )
}

export default Modal 